import { faMagicWandSparkles } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { Link } from 'react-router-dom';
import { UserSettingsPopup } from '~/components/users/settings/ui/UserSettingsPopup';

type EmptyListActionsProps = {
  listType: 'Site' | 'Job' | 'Contact' | 'Item' | 'Asset' | 'Template';
  hasWizard?: boolean;
  image?: string;
  imageAlt?: string;
  typeLabel?: string;
  buttonLabel?: string;
};

export function EmptyListActions({
  listType,
  hasWizard,
  image,
  imageAlt,
  typeLabel,
  buttonLabel,
}: EmptyListActionsProps) {
  const [openWizard, setOpenWizard] = useState<boolean>(false);
  const { t } = useTranslation();

  // Determine which styling variant to use
  const hasImage = !!image;

  return (
    <div
      className={
        hasImage
          ? 'flex h-full max-w-full flex-1 flex-col items-center justify-center overflow-x-hidden px-7 py-10 text-center'
          : 'flex flex-grow flex-col items-center justify-center text-center'
      }
    >
      {image && (
        <img
          src={image}
          alt={imageAlt || `Empty ${listType.toLowerCase()} illustration`}
          className={
            listType === 'Site'
              ? 'mb-6 w-full max-w-4xl'
              : 'mb-6 w-full max-w-lg'
          }
        />
      )}
      <div
        className={
          hasImage ? 'mb-1 text-lg' : 'mb-4 max-w-[25rem] px-4 pt-12 text-xl'
        }
      >
        You don&apos;t have any{' '}
        {typeLabel ? (
          <>
            <span className='font-semibold'>{typeLabel}</span> yet.
          </>
        ) : (
          <>
            {t(listType.toLocaleLowerCase())}s here. Would you like to create a
            new {t(listType.toLocaleLowerCase())}?
          </>
        )}
      </div>
      {typeLabel && <div className='text-grey-60 mb-6'>Want to add one?</div>}

      <Link
        className='mt-4 flex rounded-3xl bg-blue-90 px-4 py-2 font-medium text-white transition-all duration-200 hover:scale-105 hover:bg-brand active:scale-95 active:bg-brand-darker'
        to='new'
      >
        + {buttonLabel || t(listType.toLocaleLowerCase())}
      </Link>

      {hasWizard && (
        <>
          <div className='max-w-[400px] pt-12'>Want a bit more help?</div>
          <div
            onClick={() => setOpenWizard(true)}
            className='mt-4 flex cursor-pointer items-center justify-center gap-2 rounded-3xl border border-blue-90 px-4 py-2 font-medium text-blue-90 transition-all  hover:border-grey-90 hover:text-grey-90'
          >
            <FontAwesomeIcon
              icon={faMagicWandSparkles}
              className='text-yellow'
            />
            {listType} creation wizard
          </div>
          <UserSettingsPopup
            isOpen={openWizard}
            onClose={() => setOpenWizard(false)}
          >
            Popup content - help steps - go here
          </UserSettingsPopup>
        </>
      )}
    </div>
  );
}
